"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransformOptions = void 0;
const pixel_ratio_1 = __importDefault(require("@padlet/pixel-ratio"));
const presets_1 = __importDefault(require("./presets"));
const DEFAULT_BREAKPOINT_WIDTH = 60;
function getTransformOptions(requestedOptions) {
  const presetOptions = requestedOptions.preset ? presets_1.default[requestedOptions.preset] : {};
  const options = Object.assign(presetOptions, requestedOptions);
  const transformOptions = {};
  transformOptions.align = options.align;
  transformOptions.ar = options.ar;
  transformOptions.effect = options.effect;
  transformOptions.crop = options.crop || 'limit';
  transformOptions.dpr = options.dpr == 'auto' || !options.dpr ? Math.ceil(pixel_ratio_1.default) : Math.ceil(parseFloat(options.dpr.toString()));
  if (!options.gravity && (options.crop == 'fill' || options.crop == 'lfill')) {
    transformOptions.gravity = 'auto';
  } else {
    transformOptions.gravity = options.gravity;
  }
  transformOptions.format = options.format;
  transformOptions.metadata = options.metadata;
  transformOptions.trim = options.trim;
  transformOptions.blur = options.blur;
  transformOptions.quality = options.quality;
  if (options.breakpoint && options.width) {
    const breakpointWidth = options.breakpoint === true ? DEFAULT_BREAKPOINT_WIDTH : options.breakpoint;
    transformOptions.width = breakpointWidth * Math.ceil(options.width / breakpointWidth);
    if (options.height) {
      transformOptions.height = Math.floor(options.height * transformOptions.width / options.width);
    }
  } else {
    transformOptions.width = options.width;
    transformOptions.height = options.height;
  }
  return transformOptions;
}
exports.getTransformOptions = getTransformOptions;